module.exports = __webpack_public_path__ + "img/icon-arrow-left.feb84533.svg";